export default __webpack_public_path__ + "static/media/clever-logo.a566d014.svg";